import { EmailPayloadBase } from "../email-payload-base";

export class AsicDocumentsBulkEsignEmailPayload extends EmailPayloadBase {
  static override $type = 'AsicDocumentsBulkEsignEmailPayload';
  companyNames: string[];
  year: string;
  directorFirstName: string;
  directorFullName: string;
  username: string;
  signUrl: string;
  payUrl: string;
  customMessage: string;

  constructor(data: Partial<AsicDocumentsBulkEsignEmailPayload> = {}) {
    super(data);

    this.companyNames = data.companyNames ?? [];
    this.year = data.year ?? '';
    this.directorFirstName = data.directorFirstName ?? '';
    this.directorFullName = data.directorFullName ?? '';
    this.username = data.username ?? '';
    this.signUrl = data.signUrl ?? '';
    this.payUrl = data.payUrl ?? '';
    this.customMessage = data.customMessage ?? '';
  }
}
